/**
 * Video Attachment Component
 * Displays video attachments with HTML5 player
 */

import { Maximize2 } from 'lucide-react';
import type { MessageAttachment } from '@/types/api.types';
import { getAttachmentUrl } from '@/services/attachments.service';

interface VideoAttachmentProps {
  attachment: MessageAttachment;
  onGalleryOpen?: (attachmentId: string) => void;
}

const VideoAttachment = ({ attachment, onGalleryOpen }: VideoAttachmentProps) => {
  const videoUrl = getAttachmentUrl(attachment.id);

  return (
    <div className="max-w-xl group relative">
      <video
        controls
        className="w-full rounded-lg bg-black"
        preload="metadata"
      >
        <source src={videoUrl} type={attachment.mime_type} />
        Твоят браузър не поддържа видео възпроизвеждане.
      </video>

      {/* Expand button — opens in gallery viewer */}
      {onGalleryOpen && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            onGalleryOpen(attachment.id);
          }}
          className="absolute top-2 right-2 p-1.5 bg-black/60 hover:bg-black/80 text-white/70 hover:text-white rounded-md opacity-0 group-hover:opacity-100 transition-opacity z-10"
          aria-label="Отвори на цял екран"
        >
          <Maximize2 className="w-4 h-4" />
        </button>
      )}

      <p className="text-xs text-gray-500 mt-1">{attachment.file_name}</p>
    </div>
  );
};

export default VideoAttachment;
